export const TYPE = {
  fill: 'fill',
  outline: 'outline',
};

export const COLOR_PROFILES = {
  success: {
    icon: 'success-700',
    fill: '#028329',
    outline: '#43A34D',
    overRideIconColor: false,
  },
  critical: {
    icon: 'critical-700',
    fill: '#CC1C10',
    outline: '#EF5955',
    overRideIconColor: false,
  },
  savi: {
    icon: 'critical-700',
    fill: '#CC1C10',
    outline: '#4C00AC',
    overRideIconColor: false,
  },
  normal: {
    icon: 'navy-900',
    fill: '#254B86',
    outline: '#6888B5',
    overRideIconColor: false,
  },
  sod: {
    icon: 'neutral-000',
    fill: '#F6A91C',
    outline: '#F6A91C',
    overRideIconColor: false,
  },
  sodFunctions: {
    icon: 'warning-900',
    fill: '#FFF1D9',
    outline: '#5C3C00',
    overRideIconColor: true,
  },
  list: {
    icon: 'neutral-1000',
    fill: '#F2F4F8',
    outline: '#212328',
    overRideIconColor: true,
  },
};
